export default function anonymous(context
) {
var out='<!DOCTYPE html><html> <head> <title>Free Touch Pricker</title> <style type="text/css"> body { margin: 0px; padding: 0px; } '+( context.pricker.print('css') )+' </style> <script type="text/javascript"> window.onload = function () { pricker.onLoad(); }; </script> </head> <body> '+( context.pricker.print('html') )+' </body></html>';return out;
}